var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5482 2.93548C13.5482 4.55671 12.2339 5.87097 10.6127 5.87097C8.99145 5.87097 7.67719 4.55671 7.67719 2.93548C7.67719 1.31426 8.99145 0 10.6127 0C12.2339 0 13.5482 1.31426 13.5482 2.93548ZM3.38708 6.77417C5.00831 6.77417 6.32257 5.4599 6.32257 3.83868C6.32257 2.21746 5.00831 0.903198 3.38708 0.903198C1.76586 0.903198 0.451599 2.21746 0.451599 3.83868C0.451599 5.4599 1.76586 6.77417 3.38708 6.77417ZM3.91398 7.67761C1.75235 7.67761 0 9.42996 0 11.5916V18.9679H5.87097V9.6346C5.87097 8.55379 4.99479 7.67761 3.91398 7.67761ZM10.086 6.77356C12.2477 6.77356 14 8.52591 14 10.6875V18.9671H8.12903V8.73055C8.12903 7.64973 9.00521 6.77356 10.086 6.77356Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/People_Icon.a1b688c3d6c42a095fa1d5c329f2d481.svg";
export { ForwardRef as ReactComponent };